// Entry point for the build script in your package.json
import { Application } from '@hotwired/stimulus';

import HeaderController from './controllers/header_controller';
import RevealController from './controllers/reveal_controller';

const application = Application.start();

application.register('header', HeaderController);
application.register('reveal', RevealController);
